import { createAction, props } from '@ngrx/store';

export const loadPolicyDetails = createAction(
    '[Policy] Load Policy Details',
    props<{ policyNumber: string; policyTerm?: string }>()
);

export const loadPolicyDetailsSuccess = createAction('[Policy] Load Policy Details Success', props<{ data: any }>());

export const loadPolicyDetailsFailure = createAction(
    '[Policy] Load Policy Details Failure',
    props<{ error: string }>()
);

export const loadPolicyTermDetail = createAction(
    '[Policy] Load Policy Term Detail',
    props<{ payload: any; policyTerm: string }>()
);

export const loadPolicyTermDetailSuccess = createAction(
    '[Policy] Load Policy Term Detail Success',
    props<{ data: any }>()
);

export const loadPolicyTermDetailFailure = createAction(
    '[Policy] Load Policy Term Detail Failure',
    props<{ error: string }>()
);

export const updateNotes = createAction('[Policy] Update Notes', props<{ policyNumber: string; notes: any[] }>());

export const resetPolicyState = createAction('[Policy] Reset State');

// DCPolicy & DCBilling & Inbound/Outbound Comm & DMS separate load actions
export const loadPolicyData = createAction(
    '[Policy] Load DCPolicy And DCBilling',
    props<{ policyNumber: string; policyTerm?: string; effectiveDate?: string; expireDate?: string }>()
);

export const loadDCPolicySuccess = createAction(
    '[Policy] Load DCPolicy Success',
    props<{ policyNumber: string; policySnapshot: any }>()
);

export const loadDCPolicyFailure = createAction('[Policy] Load DCPolicy Failure', props<{ error: string }>());

export const loadDCBillingSuccess = createAction(
    '[Policy] Load DCBilling Success',
    props<{ policyNumber: string; billingSnapshot: any }>()
);

export const loadDCBillingFailure = createAction('[Policy] Load DCBilling Failure', props<{ error: string }>());

export const loadCommSuccess = createAction(
    '[Policy] Load Inbound & Outbound Communications Success',
    props<{ policyNumber: string; inOutCommSnapshot: any }>()
);

export const loadCommFailure = createAction(
    '[Policy] Load Inbound & Outbound Communications Failure',
    props<{ error: string }>()
);

export const loadDMSSuccess = createAction(
    '[Policy] Load Document Success',
    props<{ policyNumber: string; dmsSnapshot: any }>()
);

export const loadDMSFailure = createAction('[Policy] Load Document Failure', props<{ error: string }>());

export const loadClaimsSuccess = createAction(
    '[Policy] Load Claims Success',
    props<{ policyNumber: string; claimsSnapshot: any }>()
);

export const loadClaimsFailure = createAction('[Policy] Load Claims Failure', props<{ error: string }>());

// Retry individual failed services
export const retryDCPolicy = createAction(
    '[Policy] Retry DCPolicy',
    props<{ policyNumber: string; policyTerm?: string; effectiveDate?: string; expireDate?: string }>()
);

export const retryDCBilling = createAction(
    '[Policy] Retry DCBilling',
    props<{ policyNumber: string; policyTerm?: string }>()
);

export const retryComm = createAction(
    '[Policy] Retry Inbound & Outbound Communications',
    props<{ policyNumber: string; policyTerm?: string }>()
);

export const retryDMS = createAction('[Policy] Retry Document', props<{ policyNumber: string; policyTerm?: string }>());

export const retryClaims = createAction(
    '[Policy] Retry Claims',
    props<{ policyNumber: string; policyTerm?: string }>()
);

export const storePolicyTerms = createAction(
    '[Policy] Store Policy Terms',
    props<{ terms: string[]; termData: { term: string; startDate: string; endDate: string }[] }>()
);
export const fetchPolicyTermsSuccess = createAction(
    '[Policy] Fetch Policy Terms Success',
    props<{ terms: string[] }>()
);

export const loadPayPlanSuccess = createAction(
    '[Policy] Load PayPlan Success',
    props<{ policyNumber: string; payPlanSnapshot: any }>()
);

export const loadPayPlanFailure = createAction('[Policy] Load PayPlan Failure', props<{ error: string }>());

export const retryPayPlan = createAction(
    '[Policy] Retry PayPlan',
    props<{ policyNumber: string; effDt: string; expDt: string }>()
);

export const refreshDCPolicy = createAction(
    '[Policy] Refresh DCPolicy After Edit',
    props<{ policyNumber: string; effectiveDate?: string; expireDate?: string }>()
);

export const verifyContactSuccess = createAction(
    '[Policy] Verify Contact Success',
    props<{
        policyNumber: string;
        insuredPhoneValid: boolean | null;
        insuredPhoneCellular: boolean | null;
        insuredEmailValid: boolean | null;
        producerPhoneValid: boolean | null;
        producerPhoneCellular: boolean | null;
        producerEmailValid: boolean | null;
        additionalInsuredValidation: {
            phoneValid: boolean | null;
            phoneCellular: boolean | null;
            emailValid: boolean | null;
        }[];
        additionalInterestValidation: { emailValid: boolean | null }[];
        designatedThirdPartyValidation: { emailValid: boolean | null }[];
        escrowValidation: { emailValid: boolean | null }[];
        coOwnerValidation: { phoneValid: boolean | null; phoneCellular: boolean | null; emailValid: boolean | null }[];
    }>()
);
